import { Controller } from "@hotwired/stimulus";

// Disables all input elements that are currently hidden in a fieldset. Re-enables them when the fieldset is shown.
// Prevents hidden required fields from preventing form submission.
export default class extends Controller {
  connect() {
    this.fieldsets = this.element.querySelectorAll("fieldset");
    this.fieldsets.forEach(fieldset => {
      this.toggleInputDisabled(fieldset)
      this.observer = new MutationObserver(this.mutationObserverCallback.bind(this));
      this.observer.observe(fieldset, { attributes: true });
    });
  }

  mutationObserverCallback(mutationsList, observer) {
    mutationsList.forEach(mutation => {
      if (mutation.attributeName === 'hidden') {
        this.toggleInputDisabled(mutation.target)
      }
    });
  }

  toggleInputDisabled(fieldset) {
    const disableableElements = fieldset.querySelectorAll('input, select, textarea, button')
    if (fieldset.hidden) {
      disableableElements.forEach(element => element.setAttribute("disabled", "disabled"));
    } else {
      disableableElements.forEach(element => element.removeAttribute("disabled"));
    }
  }
}
